module.exports = __webpack_public_path__ + "img/videoBg.9ba4ab83.png";